import React, { useState } from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import FoodFluenceModal from './FoodFluenceModal';
import PhoneVerificationModal from './PhoneVerificationModal';
import { ff } from '../theme';

const FoodFluenceCard: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);

  return (
    <>
      <Box
        as="button"
        w="100%"
        textAlign="left"
        fontFamily="display"
        bg="white"
        border="1px solid"
        borderColor={ff.card}
        borderRadius="20px"
        p="18px"
        cursor="pointer"
        _hover={{ bg: ff.grey }}
        transition="background 0.15s"
        onClick={() => setIsModalOpen(true)}
      >
        <HStack spacing={3} align="center">
          <Box flex={1} minW={0}>
            <Text fontWeight={600} fontSize="17px" color={ff.ink} mb={1}>
              What is FoodFluence?
            </Text>
            <Text fontSize="15px" color={ff.body} lineHeight="1.5">
              A platform that connects brands and creators for authentic, high-impact collaborations.
            </Text>
          </Box>
          <ArrowForwardIcon w={5} h={5} color={ff.ink} flex="none" />
        </HStack>
      </Box>
      
      <FoodFluenceModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onGetStarted={() => {
          setIsModalOpen(false);
          setIsPhoneModalOpen(true);
        }}
      />
      
      <PhoneVerificationModal
        isOpen={isPhoneModalOpen}
        onClose={() => setIsPhoneModalOpen(false)}
      />
    </>
  );
};

export default FoodFluenceCard;